function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from '@shared/components/spzaComponent';
import { getFuturePriceVariablePriceString } from '@shared/utils/pricing';
import { MessageBar, MessageBarType, Stack, Text } from '@fluentui/react';
import FuturePriceWarning from '@shared/components/futurePriceWarning';
import { SeatsPicker } from './seatsPicker';
import { BillingFrequencyChoiceGroup, GenerateLabelAndTooltip } from './billingFrequencyChoiceGroup';
import { BillingTermChoiceGroup } from './billingTermChoiceGroup';
import { RecurringOption } from '@appsource/components/recurringOptions';
import { isOneTimePaymentOffer } from '@shared/utils/onetimepaymentoffers';
import { MSuserErrorBanner } from '@appsource/components';
import { PaymentMethodsInfo } from '@appsource/components/PaymentMethodsInfo/PaymentMethodsInfo';
import { getUserType } from '@appsource/utils/checkoutSettings';
import { UserType } from '@microsoft-commerce/purchase-blends-component-library';
import { isMaccUser } from '@shared/utils/userUtils';
import { isBagTransactable } from '@shared/utils/appUtils';
export class BillingPaymentControl extends SpzaComponent {
    getPricesStrings() {
        var _this_props_checkout_items__unitPrice, _this_props_checkout_items_;
        return getFuturePriceVariablePriceString({
            countryCode: this.props.billingCountry,
            currency: (_this_props_checkout_items_ = this.props.checkout.items[0]) === null || _this_props_checkout_items_ === void 0 ? void 0 : (_this_props_checkout_items__unitPrice = _this_props_checkout_items_.unitPrice) === null || _this_props_checkout_items__unitPrice === void 0 ? void 0 : _this_props_checkout_items__unitPrice.currency,
            context: this.context,
            futureSku: this.state.futureSku,
            locale: this.props.config.locale
        });
    }
    renderImpl() {
        const { futurePriceMonthly, futurePriceYearly } = this.getPricesStrings();
        const { app, app: { entityId, futurePricesInformation }, checkout: { items }, billingCountry, setBillingTerm, setSelectedTerm, users, users: { tenantsDetails: { details: { tenantId } }, roleDefinitions = [] }, isProfessionalService } = this.props;
        const { isQuantifiable } = items[0];
        const isOneTimePayment = isOneTimePaymentOffer(entityId);
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    className: "new-checkout-step-header ms-fontWeight-semibold",
                    children: this.context.loc('Checkout_Step_PriceAndBilling')
                }),
                /*#__PURE__*/ _jsx(MSuserErrorBanner, {
                    context: this.context,
                    tenantId: tenantId
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "billing-container",
                    children: [
                        !!this.state.futureSku && /*#__PURE__*/ _jsx("div", {
                            className: "futurePrice-PaymentControlContainer",
                            children: /*#__PURE__*/ _jsx(FuturePriceWarning, {
                                futurePrices: futurePricesInformation
                            }, "futurePricePayment")
                        }),
                        !isOneTimePayment && /*#__PURE__*/ _jsx(BillingTermChoiceGroup, {
                            items: items,
                            setBillingTerm: setBillingTerm,
                            setSelectedTerm: setSelectedTerm
                        }),
                        !isProfessionalService ? /*#__PURE__*/ _jsx(BillingFrequencyChoiceGroup, {
                            billingCountryCode: billingCountry,
                            futurePriceMonthly: futurePriceMonthly,
                            futurePriceYearly: futurePriceYearly,
                            items: items,
                            setSelectedTerm: this.props.setSelectedTerm,
                            locale: this.props.config.locale
                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(GenerateLabelAndTooltip, {
                                    context: this.context
                                }),
                                /*#__PURE__*/ _jsx(Stack, {
                                    children: this.context.loc('Checkout_PriceAndBilling_OneTimePayment_ProfessionalServices', 'one-time payment')
                                })
                            ]
                        }),
                        !isOneTimePayment && !isProfessionalService && /*#__PURE__*/ _jsx(RecurringOption, _object_spread({}, this.props)),
                        isQuantifiable && /*#__PURE__*/ _jsx(SeatsPicker, _object_spread({}, this.props)),
                        isProfessionalService && // Using data-testid because MessageBar text render in test issue https://github.com/microsoft/fluentui/issues/17004
                        /*#__PURE__*/ _jsx(Stack, {
                            tokens: {
                                padding: '8px 0'
                            },
                            "data-testid": "final-price-message",
                            children: /*#__PURE__*/ _jsx(Stack.Item, {
                                align: "start",
                                children: /*#__PURE__*/ _jsx(MessageBar, {
                                    messageBarType: MessageBarType.info,
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        children: this.context.loc('Final_Price_Placement_Message', 'The final price will be shown in the payment section')
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(PaymentMethodsInfo, {
                            entityId: entityId,
                            isMacc: isMaccUser(users),
                            isAdminUser: getUserType(roleDefinitions) === UserType.myOrg,
                            isBagOffer: isBagTransactable(app)
                        })
                    ]
                })
            ]
        });
    }
    constructor(props, context){
        var _this_props_app;
        super(props, context), _define_property(this, "context", void 0);
        const futurePrices = (_this_props_app = this.props.app) === null || _this_props_app === void 0 ? void 0 : _this_props_app.futurePricesInformation;
        const futureSku = futurePrices && futurePrices.skus.find((futurePriceSku)=>futurePriceSku.id === this.props.checkout.items[0].id);
        this.state = {
            futureSku
        };
    }
}
BillingPaymentControl.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    renderErrorModal: PropTypes.func
};
